"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LabelModule = _interopRequireDefault(require("./Label.module.scss"));

var _excluded = ["className", "variant", "accent", "as", "forwardedRef"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Label = function Label(_ref) {
  var _cx;

  var className = _ref.className,
      variant = _ref.variant,
      accent = _ref.accent,
      Base = _ref.as,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Base, _extends({}, props, {
    ref: forwardedRef,
    className: (0, _classnames["default"])((_cx = {}, _defineProperty(_cx, "".concat(_LabelModule["default"].label, " ").concat(className), true), _defineProperty(_cx, _LabelModule["default"][accent], accent), _defineProperty(_cx, _LabelModule["default"][variant], variant), _cx))
  }));
};

process.env.NODE_ENV !== "production" ? Label.propTypes = {
  as: _propTypes["default"].any,
  variant: _propTypes["default"].oneOf(['border', 'fill', 'round', 'circle']),
  accent: _propTypes["default"].oneOf(['athens', 'casper', 'waterloo', 'jungle-green', 'texas-rose', 'persimmon', 'dodger-blue', 'heliotrope', 'mystic', 'malibu', 'mirage', 'lima']),
  className: _propTypes["default"].string
} : void 0;
Label.defaultProps = {
  as: 'span',
  variant: undefined,
  accent: undefined,
  className: ''
};
var _default = Label;
exports["default"] = _default;